import main from '../../components/main';

const mainPage = () =>  main();

export default mainPage;
